import React from 'react';
import ConfirmationModal from '../Packages/ConfirmationModal';

const BookingDetail = () => {
    return (
        <div className='h-[80vh]'>
            <ConfirmationModal ></ConfirmationModal>
        </div>
    );
};

export default BookingDetail;